/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: dashboard
 *| (C) Copyright IBM Corp. 2016, 2017
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class'
], function(BaseClass) {


	var GlassUtil = BaseClass.extend({

		/** Returns true if we're in 'development' mode, false otherwise. */
		isDevMode: function(services) {
			if (services && services.biGlass && services.biGlass.glassContext && services.biGlass.glassContext.isDevInstall) {
				return services.biGlass.glassContext.isDevInstall();
			}
			return false;
		},

		getAjaxService: function(glassContext) {
			return glassContext.services.ajax;
		}
	});
	return new GlassUtil();
});
